import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewModule } from '../bing-maps/view/view.module';
import { ApplicationPipesModule } from '../application-pipes-module/application-pipes.module';
import { InstitutionsComponent } from './institutions.component';
import { InstitutionsFiltersComponent } from './institutions-filters.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { LibraryListModule } from '../search/object-detail/bottom-list/library-list/library-list.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {OrderModule} from 'ngx-order-pipe';
import {InstitutionsListComponent} from './insititutions-list/institutions-list.component';
import {InstitutionsItemComponent} from './institutions-item/institutions-item.component';

@NgModule({
  imports: [
    CommonModule,
    LibraryListModule,
    ViewModule,
    OrderModule,
    ReactiveFormsModule,
    ApplicationPipesModule,
    MatAutocompleteModule,
    FormsModule,
  ],
  declarations: [InstitutionsComponent, InstitutionsFiltersComponent, InstitutionsListComponent, InstitutionsItemComponent],
  exports: [InstitutionsComponent]
})
export class InstitutionsModule {
}
